/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1081
 */

module.exports = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"]
